var _style, _path, _rect, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSimCardIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 191 221",
    style: {
      enableBackground: "new 0 0 191 221"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st1{fill:none;stroke:#71D400;stroke-width:16;stroke-linecap:round;stroke-linejoin:round;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M167,206H23c-4.4,0-8-3.6-8-8V22c0-4.4,3.6-8,8-8h96l56,56v128C175,202.4,171.4,206,167,206z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 102,
    className: "st1",
    width: 96,
    height: 72
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 79,
    y1: 134,
    x2: 79,
    y2: 174
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 111,
    y1: 134,
    x2: 111,
    y2: 174
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimCardIcon);
export default __webpack_public_path__ + "static/media/sim_card_icon.25d61fe11d328beade25a4edf89add43.svg";
export { ForwardRef as ReactComponent };